const initialState = {
  sideOpenState: false,
  sideData: undefined
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_SIDE_OPEN_STATE': {
      return { ...state, sideOpenState: payload.sideOpenState };
    }
    case 'SET_SIDE_DATA': {
      return {
        ...state,
        sideData: payload.sideData
      };
    }
    default: {
      return state;
    }
  }
}
